var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"option"},[_c('input',_vm._b({attrs:{"type":"checkbox"},on:{"change":_vm.onChange}},'input',_vm.checkboxProps,false)),_c('span',{staticClass:"checkbox"}),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }